import { useLang, LANGUAGES } from "@/lib/i18n";

/**
 * Compact language switcher. Persists to localStorage via LanguageContext.
 * Placed in the app header (Dashboard, Storyboard, etc.).
 */
export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="language-switcher"
      className={`flex items-center gap-0.5 border border-[#2A2D35] rounded-sm bg-[#181A1F]/60 p-0.5 ${className}`}
      role="group"
      aria-label="Language selector"
    >
      {LANGUAGES.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            data-testid={`lang-btn-${l.code}`}
            aria-pressed={active}
            onClick={() => setLang(l.code)}
            className={
              "px-2 py-1 text-[10px] sm:text-[11px] font-mono uppercase tracking-widest transition-colors rounded-[2px] " +
              (active
                ? "bg-[#D4AF37] text-[#0F1115]"
                : "text-[#A19E95] hover:text-[#D4AF37]")
            }
            title={l.label}
          >
            {l.short}
          </button>
        );
      })}
    </div>
  );
}
